"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfMulticall__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "multicall",
        outputs: [
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "data",
                type: "bytes[]",
            },
        ],
        name: "tryMulticall",
        outputs: [
            {
                internalType: "bool[]",
                name: "successes",
                type: "bool[]",
            },
            {
                internalType: "bytes[]",
                name: "returndata",
                type: "bytes[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SelfMulticall__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.SelfMulticall__factory = SelfMulticall__factory;
//# sourceMappingURL=SelfMulticall__factory.js.map